// Form/table id of the campaign attachments storage (registered in the legacy
// CrudStore as CrudStoreItem.CampaignAttachments).
export const CAMPAIGN_ATTACHMENTS_FORM_ID = '2061'
